var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCourseChemistry = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 98,
    viewBox: "0 0 104 98",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 98,
    rx: 10,
    fill: "url(#paint0_linear_3333_313364)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4229 72H65.5775C68.2079 72 70.5853 70.6739 71.9371 68.4526C73.289 66.231 73.355 63.5416 72.114 61.2588L64.3202 46.9218L64.32 46.921L64.3194 46.9203L58.6873 36.5597V26.706H60.3204C60.799 26.706 61.1869 26.3241 61.1869 25.853C61.1869 25.3819 60.799 25 60.3204 25H42.6796C42.201 25 41.8131 25.3819 41.8131 25.853C41.8131 26.3241 42.201 26.706 42.6796 26.706H44.3127V36.5597L30.886 61.2588C29.645 63.5416 29.711 66.231 31.0629 68.4522C32.4147 70.6739 34.7925 72 37.4229 72ZM45.9434 37.1761C46.0107 37.0524 46.0458 36.9141 46.0458 36.7737V26.706H56.9542V36.7737C56.9542 36.9141 56.9893 37.0524 57.0566 37.1761L62.3594 46.9308C56.2393 49.7812 53.1623 48.2108 50.1926 46.6795C47.7495 45.4188 45.2329 44.1331 41.4413 45.458L45.9434 37.1761ZM40.0926 47.9389L32.4142 62.0635C31.4631 63.8132 31.5139 65.8736 32.5496 67.5759C33.5854 69.2777 35.4073 70.294 37.4229 70.294H65.5775C67.5931 70.294 69.4146 69.2777 70.4504 67.5759C71.4861 65.8736 71.5369 63.8132 70.5858 62.0635L63.1789 48.4382C60.3829 49.7524 58.1181 50.246 56.2091 50.246C53.3736 50.246 51.3085 49.1809 49.3902 48.1915L49.3883 48.1905C46.5781 46.7414 44.3451 45.601 40.0926 47.9389Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 65C42 66.654 40.654 68 39 68C37.346 68 36 66.654 36 65C36 63.346 37.346 62 39 62C40.654 62 42 63.346 42 65ZM40.2948 65C40.2948 64.2739 39.7261 63.7052 39 63.7052C38.2739 63.7052 37.7052 64.2739 37.7052 65C37.7052 65.714 38.286 66.2948 39 66.2948C39.714 66.2948 40.2948 65.714 40.2948 65Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63 62C63 63.6544 61.6544 65 60 65C58.3456 65 57 63.6544 57 62C57 60.3456 58.3456 59 60 59C61.6544 59 63 60.3456 63 62ZM61.3908 62C61.3908 61.2201 60.7799 60.6092 60 60.6092C59.2201 60.6092 58.6092 61.2201 58.6092 62C58.6092 62.7669 59.2331 63.3908 60 63.3908C60.7669 63.3908 61.3908 62.7669 61.3908 62Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 56.5C52 58.9815 49.9815 61 47.5 61C45.0185 61 43 58.9815 43 56.5C43 54.0185 45.0185 52 47.5 52C49.9815 52 52 54.0185 52 56.5ZM50.2808 56.5C50.2808 54.9667 49.0333 53.7192 47.5 53.7192C45.9667 53.7192 44.7192 54.9667 44.7192 56.5C44.7192 58.0333 45.9667 59.2808 47.5 59.2808C49.0333 59.2808 50.2808 58.0333 50.2808 56.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3333_313364",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCA443"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCourseChemistry, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CourseChemistry.7f4f7fd7.svg";
export { ForwardRef as ReactComponent };